import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import type { NotificationItem } from '../../../lib/teacherApi';

export default function NotificationsCard({
  notifications,
  onMarkAllRead,
}: {
  notifications: NotificationItem[];
  onMarkAllRead: () => Promise<void>;
}) {
  const unread = notifications.filter((n) => !n.is_read).length;

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Notificări</h2>
        <Button
          variant="ghost"
          size="sm"
          iconName="CheckCheck"
          onClick={onMarkAllRead}
          disabled={unread === 0}
          className="w-full sm:w-auto"
        >
          Marchează toate ca citite
        </Button>
      </div>

      {notifications.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-8">
          <Icon name="BellOff" size={48} className="text-muted-foreground mb-3" />
          <p className="text-sm text-muted-foreground text-center">Nu există notificări</p>
        </div>
      ) : (
        <div className="space-y-3">
          {notifications.slice(0, 6).map((n) => (
            <div
              key={n.id}
              className={`p-3 border border-border rounded-md ${!n.is_read ? 'bg-muted/50' : ''}`}
            >
              <div className="flex items-start gap-2">
                <Icon name="Bell" size={16} className="text-muted-foreground mt-0.5" />
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground truncate">{n.title}</div>
                  <div className="text-xs text-muted-foreground line-clamp-2">{n.content}</div>
                  <div className="mt-1 text-[11px] text-muted-foreground">
                    {new Date(n.created_at).toLocaleString()}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
